import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React, { useRef } from "react";
import styles from "./Thumbnail.module.scss";
import ProgressCircle from "@/Atoms/ProgressCircle/ProgressCircle";

export default (
  {
    id,
    src,
    progress,
    onDelete
  }: {
    id: string | number
    src: string
    progress?: number
    onDelete: (e: any) => void
  }) => {
  const {isDragging, attributes, listeners, node, setNodeRef, transform, transition} = useSortable({id});

  const image = useRef<HTMLImageElement>(null);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onDelete(e);
  };

  return <div
    ref={setNodeRef}
    style={style}
    className={`w-32 h-32 border rounded overflow-hidden ${styles.thumbnail} ${isDragging ? styles.dragging : ''}`}
  >

    <img
      src={src}
      alt=""
      className={styles.image}
      draggable={false}
      ref={image}
    />
    {progress && <ProgressCircle
      percentage={progress}
      className={styles.progress}
    />}

    <div className={styles.toolbar}>
      <button
        onClick={(e) => handleDeleteClick(e)}
        onPointerDown={(e) => e.stopPropagation()}
        title={'Verwijder afbeelding'}
        className={styles.delete}>
        <i className={'fa-regular fa-trash-can'}></i>
      </button>
      <button
        onClick={(e) => handleDeleteClick(e)}
        onPointerDown={(e) => e.stopPropagation()}
        {...attributes}
        {...listeners}
        title={'Sorteer afbeelding'}
        className={styles.move}>
        <i className="fa-solid fa-grip-vertical"></i>
      </button>
    </div>
  </div>
};